import { required, decimal, requiredIf } from 'vuelidate/lib/validators'

export default {
    currentValue: {
        required,
        decimal,
    },
    satisfaction: {},
    generalComments: {},
    difficultiesFound: {},
    rangeId: {
        required: requiredIf(nestedModal => {
            return nestedModal.isCheckInByRange
        }),
    },
    isCheckInByRange: {},
}
